'use client';

import { useAddToCartAnalytics } from '@app/pdp/components/AddToCart/hooks';
import { useAddToCTCartDrawer } from '@app/pdp/hooks';
import { usePageLayout, useCart } from '@libs/common-next';
import type { AddItemRequestBody, ItemUI } from '@libs/common-node';

type UseAddToCTCart = {
    addToCTCart: (
        body: AddItemRequestBody,
        shouldThrowError?: boolean
    ) => Promise<void>;
    isLoading: boolean;
};

export const useAddToCTCart = (): UseAddToCTCart => {
    const { openAddedToCartDrawer } = useAddToCTCartDrawer();
    const addToCartAnalytics = useAddToCartAnalytics();
    const { setErrorAlert } = usePageLayout();
    const { isLoading, addItem } = useCart();

    const addToCTCart = async (
        body: AddItemRequestBody,
        shouldThrowError?: boolean
    ) => {
        const ctCart = await addItem(body);

        if (ctCart?.id) {
            addToCartAnalytics(body, ctCart.currency);

            const newItem = ctCart?.fulfillmentGroups
                .reduce(
                    (items, group) => [...items, ...group.items],
                    [] as ItemUI[]
                )
                .find(item => item.sku === body.sku);

            openAddedToCartDrawer(newItem ? [newItem] : []);
        } else {
            console.error('An error happened when trying to add to cart.');
            setErrorAlert(true);
            if (shouldThrowError) {
                throw new Error();
            }
        }
    };

    return {
        addToCTCart,
        isLoading,
    };
};
